const ENV = process.env.REACT_APP_ENV

const isDEV = ENV === 'development'
const isPRE = ENV === 'pre'
const isPRO = ENV === 'production'

export default {
  isDEV, isPRE, isPRO,
  displayEcommercePlugin(companyId) {
    if (companyId  === '6492fe756245ed00121da16d') return true
    if (!isPRO) return true

    return false
  },
  displayEcommerceAV(companyId) {
    if (companyId  === '6492fe756245ed00121da16d') return true
    if (!isPRO) return true

    return false
  },
  displayInChat: !isPRO,
  displayGlobalSearch: !isPRO,
  displayGlobalSearchSmartchat: isDEV,
  displayMultiLang: isDEV
}
